import React, { Component } from 'react';
import Icon from '../Icon';

class SvgIcon extends Component {
  render() {
    return (
      <Icon {...this.props}>
        {(onAction, width, height, path) => (
          <div>
            <svg
              className={path}
              onClick={onAction}
              xmlns="http://www.w3.org/2000/svg"
              width={width}
              height={height}
            >
              <path d={this.props.path} />
            </svg>
          </div>
      )}
      </Icon>);
  }
}

export default (SvgIcon);



// WEBPACK FOOTER //
// ./src/components/icons/svg-icon/SvgIcon.jsx